import React, { useState } from "react";
import sign from "../../static/logo-new.png";
import check from "../../static/check.png";
import Modal from "antd/lib/modal/Modal";
import popupBG from "../../static/popupBG.png";
import "./game.scss";

export default function Progressbar({ steps, current, history }) {
  const [popupVisible, setpopupVisible] = useState(false);

  const openPopup = () => {
    setpopupVisible(true);
  };

  const closePopup = () => {
    setpopupVisible(false);
  };

  const clickBackToMain = () => {
    history.push("/");
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <img
          alt="sign"
          src={sign}
          style={{ height: "70px", width: "70px", cursor: "pointer" }}
          onClick={openPopup}
        />
        {steps.map((element, index) => {
          let actualCurrent = current;
          if (element.ending === true) {
            actualCurrent = current + 1;
          }
          return (
            <div key={element.id} style={{ display: "flex" }}>
              <div style={{ paddingTop: "2em" }}>
                <div className="line" />
              </div>
              <div style={{ paddingTop: "2em" }}>
                {index > actualCurrent - 1 ? (
                  <div
                    className="circle"
                    style={{ opacity: index > current ? "0.5" : "1" }}
                  />
                ) : (
                  <img alt="check" src={check} className="check" />
                )}
              </div>
            </div>
          );
        })}
      </div>
      <Modal
        visible={popupVisible}
        closable={false}
        footer={null}
        centered
        bodyStyle={{
          backgroundImage: `url("${popupBG}")`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "#A53333",
          height: "655px",
          color: "#ffffff",
        }}
        width={636}
      >
        <div className="progress-title">
          Biztosan megszakítod a regisztrációt?
        </div>
        <div className="progress-text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut.
        </div>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button className="progress-main-button" onClick={clickBackToMain}>
            Tovább a főoldalra
          </button>
          <button className="progress-cancel-button" onClick={closePopup}>
            Mégsem
          </button>
        </div>
      </Modal>
    </div>
  );
}
